import * as _ from 'lodash'
import { observable } from 'mobx'
import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { Button, Modal } from 'react-bootstrap'
import Form, { IChangeEvent } from 'react-jsonschema-form'
import {
    getQuestionnaireStatusClass,
    getQuestionnaireStatusText,
    getQuestionnaireStatusTextForList,
    IQuestionnaireUserHistoryItem,
    QuestionnaireStatus
} from '../../../Model/Questionnaire'
import HttpActionsService from '../../../Services/HttpActionsService'
import LocalizationStore from '../../../Stores/LocalizationStore'
import UserStore from '../../../Stores/UserStore'

export interface IQuestionnaireAssignViewProps {
    status: QuestionnaireStatus,
    qId: string,
    inProgressByUserId: string,
    history: Array<IQuestionnaireUserHistoryItem>,
    className?: string,
    localizationStore?: LocalizationStore,
    httpActionsService?: HttpActionsService
    userStore?: UserStore
}

export function getQuestionnaireStatusWithAssignSchema(): any {
    return {
        'type': 'object',
        'required': [
            'qId',
            'status',
            'comment'
        ],
        'properties': {
            'qId': {
                'type': 'string'
            },
            'status': {
                'type': 'number'
            },
            'userId': {
                'type': 'string'
            },
            'comment': {
                title: LocalizationStore.getInstance().t('Add comment'),
                'type': 'string'
            }
        }
    }
}

export const UIQuestionnaireStatusWithAssignSchema = {
    'qId': {
        'ui:widget': 'hidden'
    },
    'status': {
        'ui:widget': 'hidden'
    },
    'userId': {
        'ui:widget': 'hidden'
    },
    'comment': {
        'ui:widget': 'textarea'
    }
}

@inject('userStore')
@inject('localizationStore')
@inject('httpActionsService')
@observer
export default class QuestionnaireAssignView
    extends React.Component<IQuestionnaireAssignViewProps> {

    @observable
    isShowModal: boolean = false

    formData = {
        qId: '',
        status: 0,
        userId: '',
        comment: ''
    }

    getAssingnPossibleFromHistory(history: Array<IQuestionnaireUserHistoryItem>): Array<IQuestionnaireUserHistoryItem> {
        const { userStore, inProgressByUserId, status } = this.props
        let historyItemsToAssign: Array<IQuestionnaireUserHistoryItem> = []

        history = _.uniqBy(history, (item) => {
            return item.userId && item.userName && item.status
        })

        if (status === QuestionnaireStatus.InProgressCreditConsultant ||
            status === QuestionnaireStatus.InProgressCreditExpert) {

            if (userStore!.checkSuperAdmin ||
                userStore!.checkAdmin ||
                userStore!.checkCreditGroupAdministrator ||
                userStore!.checkCollectionGroupAdministrator) {
                historyItemsToAssign = history
            } else if (userStore!.checkCreditConsultant && userStore!.id === inProgressByUserId) {
                historyItemsToAssign = history.filter(x =>
                    [QuestionnaireStatus.InProgressCreditExpert].includes(x.status))
            } else if (userStore!.checkCreditExpert && userStore!.id === inProgressByUserId) {
                historyItemsToAssign = history.filter(x =>
                    [QuestionnaireStatus.InProgressCreditConsultant].includes(x.status))
            }
        }

        return historyItemsToAssign
    }

    showModal(e: React.MouseEvent<any>, status: QuestionnaireStatus, userId: string, userName: string) {
        const { localizationStore } = this.props
        this.formData = {
            qId: this.props.qId,
            status: status,
            userId: userId,
            comment:
                `${localizationStore!.t('AssignTo')} ${userName} ` +
                `${localizationStore!.t!('new')} ${localizationStore!.t!('status')}: ` +
                getQuestionnaireStatusText(status)
        }

        this.isShowModal = true
    }

    handleClose() {
        this.isShowModal = false
    }

    handleOk(e: IChangeEvent<any>, context: QuestionnaireAssignView) {
        const { httpActionsService } = this.props
        httpActionsService!
        .changeStatusWithAssign(
            e.formData['userId'],
            e.formData['qId'],
            e.formData['status'],
            e.formData['comment'])
        this.isShowModal = false
    }

    render() {
        const { className, history, localizationStore } = this.props

        return (
            <div className={className}>
                <div className="container">
                    <div className="row">
                        {
                            this.getAssingnPossibleFromHistory(history)
                                .map(x => {
                                    return (
                                        <div className="col-12" key={x.id}>
                                            <Button
                                                className="w-100 m-1"
                                                onClick={
                                                    (e) => this.showModal(e, x.status, x.userId, x.userName)
                                                }
                                            >
                                                {localizationStore!.t('AssignTo')} {x.userName}
                                                <span
                                                    className={`m-1 ${getQuestionnaireStatusClass(x.status)}`}
                                                >
                                                    {getQuestionnaireStatusTextForList(x.status)}
                                                </span>
                                            </Button>
                                        </div>
                                    )
                                }
                                )
                        }
                    </div>

                    <div className="row">
                        <Modal
                            show={this.isShowModal}
                            onHide={() => { return }}
                            animation={false}
                            keyboard={false}
                            backdrop={true}
                        >
                            <h6>{localizationStore!.t!('ChangeAssignConfirm')}</h6>
                            <div className="formWrapper col-12">
                                <Form
                                    onSubmit={(e) => { this.handleOk(e, this) }}
                                    schema={getQuestionnaireStatusWithAssignSchema()}
                                    uiSchema={UIQuestionnaireStatusWithAssignSchema}
                                    formData={this.formData}
                                >
                                    <Button
                                        bsStyle="link"
                                        className="col-6"
                                        onClick={(e) => { return this.handleClose() }}
                                    >
                                        {localizationStore!.t!('Cancel')}
                                    </Button>
                                    <Button
                                        type="submit"
                                        bsStyle="success"
                                        className="col-6"
                                    >
                                        {localizationStore!.t!('Ok')}
                                    </Button>
                                </Form>
                            </div>
                        </Modal>
                    </div>

                </div>
            </div >
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireAssignView.tsx